import { fetch } from "../services/api";


const getItem = (requestId) => {
    console.log('0806 - getItem - requestId', requestId)
    console.log('TODO - getItem')
    // return fetch(getRequest, {
    //     id: requestId
    // }).then(r => {
    //     console.log('0806 - getItem - r', r)
    //     if (r.data?.getRequest?.id) {
    //         const _r = { ...r.data.getRequest, evolutions: [] }
    //         if (r.data?.RequestEvolutionsByRequestId?.items) {
    //             _r.evolutions = r.data.RequestEvolutionsByRequestId.items;
    //         }
    //         console.log('0806 - getItem - _r', _r)
    //         return _r;
    //     }
    //     throw new Error('user-getRequest-error')
    // }).catch((response) => {
    //     console.log('error', response)
    // });
}

const onChangeEvent = (checkInId, cb) => {
    console.log("16ago - events - requestsActions - onChangeEvent")
    // return fetch(onSomeRequestCheckInChange, { checkInId: checkInId }).subscribe({
    //     next: (r) => {
    //         if (r.value?.data?.onSomeRequestCheckInChange) {
    //             cb(r.value.data.onSomeRequestCheckInChange)
    //         } else {
    //             console.error(r)
    //         }
    //     },
    //     error: (err) => console.error(err)
    // });
}

const addComment = (requestId, hotelId, roomOccupationId, comment) => {
    console.log('TODO - requestEvolution')
    // return fetch(requestEvolution, { 
    //             requestId: requestId,
    //             comment: comment,
    //             updatedAt: (new Date(Date.now())).toISOString()
    //         })
    //         .then(r => {
    //             if (r.data?.RequestEvolution) {
    //                 return { id: r.data.RequestEvolution, comment: comment };
    //             }
    //             throw new Error('request-add-comment-error')
    //         }).catch((response) => {
    //             console.log('error', response)
    //         });
}

const rate = (requestId, hotelId, roomOccupationId, value) => {
    console.log('TODO - rate')
    // return fetch(createReview, { 
    //     input: {
    //         hotelId: hotelId,
    //         requestId: requestId,
    //         roomOccupationId: roomOccupationId,
    //         type: 'request',
    //         review: value
    //     }
    // })
    // .then(r => {
    //     console.log('3008 r', r)
    //     // if (r.data?.createRequestEvolution?.id) {
    //     //     return { id: r.data.createRequestEvolution.id, comment: comment };
    //     // }
    //     // throw new Error('request-add-comment-error')
    // }).catch((response) => {
    //     console.log('error', response)
    // });
}

const cancel = (requestId) => {
    const data = {
        id : requestId,
        status: 'canceled'
    }
    console.log('TODO - cancel')
    // return fetch(updateStatusRequest, { input : data });

        // console.log('data', data)
        // API.graphql(graphqlOperation(updateStatusRequest, { input: data })).then((response) => {
        //     console.log('response cancel', response);
        //     API.graphql(graphqlOperation(createRequestEvolution, { input: {
        //         requestId : data.id,
        //         hotelId : hotelId,
        //         status : data.status,
        //         comment : 'Cancelado por el huésped'
        //     }})).then((r) => {
        //         console.log('createRequestEvolution r', r)
        //         // dispatch({ type: checkInConstants.RESET });
        //     })
        // }).catch((response) => {
        //     console.log('error', response)
        //     // dispatch(failure(response.data.message));
        // });
}

// const onEvolutionChangeEvent = (roomOccupationId, cb) => {
//     return fetch(onSomeRequestEvolutionRoomOccupationChange, { roomOccupationId: roomOccupationId }).subscribe({
//         next: (r) => {
//             console.log('99999', r)
//             // if (r.value?.data?.onCheckInChange) {
//             //     cb(r.value.data.onCheckInChange)
//             // } else {
//             //     console.error(r)
//             // }
//         },
//         error: (err) => console.error(err)
//     });
// }

export {
    getItem,
    onChangeEvent,
    addComment,
    rate,
    cancel 
    // onEvolutionChangeEvent
}